import { FlagProps } from '@boltenergy-be/design-system'

export type BannerProps = {
  onClick: () => void
}

export enum BannerTypes {
  BRUSSELS_BEER_PROJECT = 'brusselsBeerProject',
  MIDDLE_EAST_ENERGY_CRISIS = 'middleEastEnergyCrisis',
  VIA_VIA = 'copy',
  SIMULATION_DOWN = 'simulationDown',
  SCHEDULED_DOWNTIME = 'scheduledDowntime'
}

export type PredefinedBanner = {
  singleLine?: boolean
  noOnClick?: boolean
} & Pick<FlagProps, 'type' | 'size'> &
  (
    | {
        titleNsAndKey: string
        descriptionNsAndKey?: string
        text?: never
      }
    | {
        text: string
        titleNsAndKey?: never
        descriptionNsAndKey?: never
      }
  )
